var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeadlineContainer',{attrs:{"headline":"Partnership Activity Mails","breadcrumbs":[{text: 'Partnership Activity Mails'}]}}),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"container"},[_c('PartnershipActivityMailList',{attrs:{"portals":_vm.portals}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }